// extracted by mini-css-extract-plugin
export default {"container":"CryptoCard_container__h3tWm"};